import React, { FC } from 'react';
import MuiPagination, { PaginationProps as MuiPaginationProps } from '@mui/material/Pagination';
import { BpDesignSystem } from '../../types';

// We don't include `color` and `variant` in the props because we want to enforce the default values
export type PaginationProps = BpDesignSystem.PropsWithChildren<Omit<MuiPaginationProps, 'color' | 'variant'> & {}>;

export const Pagination: FC<PaginationProps> = ({ dataTest, ...props }) => (
  <MuiPagination data-test={dataTest} {...props} />
);
